import axios from 'axios'
export const State = {
  get jwt () {
    return window.localStorage.getItem('jwt-yoqb')
  },
  set jwt (v) {
    window.localStorage.setItem('jwt-yoqb', v)
  }
}

export const getAxios = () => {
  var baseURL = 'http://localhost:3000/'
  // debug
  baseURL = `https://yoteach-cloud.herokuapp.com/`

  // if (process.env.NODE_ENV === 'production') {
  //   baseURL = 'https://yoteach-cloud.herokuapp.com/'
  // } else if (window.location.host.indexOf('192') !== -1) {
  //   baseURL = 'http://' + window.location.hostname + ':3000/'
  // }
  let headers = {
    'Authorization': `bearer ${State.jwt}`
  }
  return axios.create({
    withCredentials: true,
    baseURL,
    headers
  })
}

export const login = (args) => {
  return getAxios().post('/jwt/login', {
    username: args.username,
    password: args.password
  }).then((resp) => {
    let data = resp.data
    State.jwt = resp.data.token
    return data
  })
}

export const register = (args) => {
  return getAxios().post('/jwt/register', {
    username: args.username,
    password: args.password
  }).then((resp) => {
    let data = resp.data
    State.jwt = resp.data.token
    return data
  })
}

export const logout = () => {
  return getAxios().post('/logout')
}

// let cloudURL = `https://yo-analytics.herokuapp.com`
export const getRangedResponse = ({ gameID, perPage = 100, pageAt = 0, dateStart, dateEnd }) => {
  let gameType = `cell-game`
  let url = `/yo-analytics-get/responses?gameSessionID=${encodeURIComponent(gameID)}&gameType=${encodeURIComponent(gameType)}&_limit=${perPage}&_start=${perPage * pageAt}&ansDate_gte=${encodeURIComponent(dateStart)}&ansDate_lte=${encodeURIComponent(dateEnd)}`
  return getAxios().post(url)
    .then((r) => {
      return r.data
    })
    .then(r => {
      return r
    })
}

// let cloudURL = `https://yo-analytics.herokuapp.com`
export const getRangedResponseAnyCloud = ({ gameID, perPage = 100, pageAt = 0, dateStart, dateEnd, gameType = `cell-game-cloud` }) => {
  let url = `/yo-analytics-get/responses?gameSessionID=${encodeURIComponent(gameID)}&gameType=${encodeURIComponent(gameType)}&_limit=${perPage}&_start=${perPage * pageAt}&ansDate_gte=${encodeURIComponent(dateStart)}&ansDate_lte=${encodeURIComponent(dateEnd)}`
  return getAxios().post(url)
    .then((r) => {
      return r.data
    })
    .then(r => {
      return r
    })
}
